import { Components } from "@thisgorilla/primate-ds";
import { Fragment, useContext } from "react";
import styled, { useTheme } from "styled-components";

import { useAppSelector } from "../../../../../redux";
import { ModalContext } from "../../../../Common/Modal";
import { hideScrollbar } from "../../../../Common/Styles";
import RenderJsonDynamic from "./RenderJsonDynamic";

const ModalContent = () => {
  const { Color, typography } = useTheme();
  const { active_post_id, post_analysis_list } = useAppSelector(
    (state) => state.postAnalysis
  );
  const post_analysis = post_analysis_list[active_post_id];
  const { contentRef, maxContentHeight } = useContext(ModalContext);

  if (!post_analysis) {
    return <Fragment />;
  }

  const { data_text, data_image } = post_analysis;

  if (!data_text && !data_image) {
    return <Fragment />;
  }

  return (
    <ModalContentContainer
      ref={contentRef}
      $maxContentHeight={maxContentHeight}
    >
      {data_text &&
        Object.keys(data_text).map((key, i) => (
          <Container key={i}>
            <Components.Text
              text={key}
              style={{ tokenStyle: typography.Body.M }}
              color={Color.text["text-emphasize-brand-bolder"].value}
              fontWeight="font-weight-semibold"
            />
            {Object.keys(data_text[key as keyof typeof data_text]).map(
              (item, index) => {
                return (
                  <RenderJsonDynamic
                    key={index}
                    data={
                      data_text[key as keyof typeof data_text][
                        item as keyof (typeof data_text)[keyof typeof data_text]
                      ]
                    }
                    title={item}
                  />
                );
              }
            )}
          </Container>
        ))}
      {data_image &&
        Object.keys(data_image).map((key, i) => (
          <Container key={i}>
            <Components.Text
              text={key}
              style={{ tokenStyle: typography.Body.M }}
              color={Color.text["text-emphasize-brand-bolder"].value}
              fontWeight="font-weight-semibold"
            />
            {Object.keys(data_image[key as keyof typeof data_image]).map(
              (item, index) => {
                return (
                  <RenderJsonDynamic
                    key={index}
                    data={
                      data_image[key as keyof typeof data_image][
                        item as keyof (typeof data_image)[keyof typeof data_image]
                      ]
                    }
                    title={item}
                  />
                );
              }
            )}
          </Container>
        ))}
    </ModalContentContainer>
  );
};

export default ModalContent;

const ModalContentContainer = styled.div<{ $maxContentHeight: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-none"].value}rem
    ${({ theme }) => theme.spacing["spacing-4"].value}rem
    ${({ theme }) => theme.spacing["spacing-8"].value}rem;
  max-height: ${({ $maxContentHeight }) => $maxContentHeight}px;
  overflow-y: auto;
  ${hideScrollbar}
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  border: ${({ theme }) => theme.border_width["border-width-thin"].value}rem
    solid ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
`;
